module.exports = __webpack_public_path__ + "img/transmission-tower.a5091194.svg";